import { assign, setup } from 'xstate';
import { showAxiosErrorAction } from '~/features/actions';
import { BOARD_CERT_CRUD_STATE } from '~/features/xstateSystem';
import { createBaseCrudMachine } from '~/machines/base-crud';
import { BoardCertification } from '~/types/mcv/boardCertifications';
import { openConfirmation, sendContextToCrud, sendLoadToCrud, setProviderData } from './actions';
import { API_CALLS } from './api';
import { emptyBoardCertForm } from './constants';
import { BoardCertMachineEvents as Events } from './events';
import { BoardCertFormValues, BoardCertSort, BoardCertContext as Context } from './types';

export const tableMachine = createBaseCrudMachine<
  BoardCertification,
  BoardCertFormValues,
  BoardCertSort
>({
  initialForm: emptyBoardCertForm,
  sort: {
    sortBy: 'id',
    cert_name: -1,
    status: -1,
    active_flag: -1,
    orig_cert_date: -1,
    specialty_name: -1,
    category: -1,
    privilege_type: -1,
    privilege_name: -1,
    assignment_date: -1,
    id: 1,
    page: 1,
    pageSize: 10,
  },
  apiCalls: API_CALLS,
});

export const boardCertMachine = setup({
  actors: {
    crudRef: tableMachine,
  },
  actions: {
    sendContextToCrud: sendContextToCrud,
    sendLoadToCrud: sendLoadToCrud,
    setProviderData: assign(setProviderData),
    sendError: showAxiosErrorAction,
    openConfirmation: openConfirmation,
  },
  types: {
    context: {} as Context,
    events: {} as Events,
    input: {} as Partial<Context>,
  },
}).createMachine({
  context: ({ spawn }) => ({
    crudRef: spawn('crudRef', {
      id: BOARD_CERT_CRUD_STATE,
      input: { data: [] },
    }),
    boardCerts: [],
    idsToDelete: [],
    providerId: -1,
    providerCategoryId: -1,
    loading: false,
    pagination: {
      page: 1,
      pageSize: 10,
      total: 0,
    },
  }),
  initial: '$_IDLE',
  states: {
    $_IDLE: {
      on: {
        ON_SEND_SHARED_CONTEXT: {
          actions: ['setProviderData', 'sendContextToCrud'],
        },
        ON_LOAD: {
          actions: ['sendLoadToCrud'],
        },
        ON_SEND_DELETE_CONFIRMATION: {
          actions: ['openConfirmation'],
        },
      },
    },
  },
});
